module.exports = __webpack_public_path__ + "short-arrow.png?5833442743099da63bda946766f79c80";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/short-arrow.png
// module id = 71
// module chunks = 0